module.exports = __webpack_public_path__ + "static/media/25-5.11a97608.mp3";